/** @jsxImportSource @emotion/react */
"use client";

import NiceModal, { useModal } from "@ebay/nice-modal-react";
import type { Interpolation } from "@emotion/react";
import type { FlaggableType } from "@packages/sdk";

import {
  numericViewportHeight,
  spacing,
  zIndices,
} from "../../../../../global/emotion";
import { cssMediaQueryMinWidthTablet } from "../../../../lib/constants/emotionMediaQueries.constants";
import { FullscreenModalModal } from "../../../_base/modals/FullscreenModalModal/FullscreenModalModal.emotion";
import { FlagRecordForm } from "../FlagRecordForm/FlagRecordForm.emotion";

const viewportStyle: Interpolation = {
  height: `calc(100vh - 148px)`,
  [cssMediaQueryMinWidthTablet]: {
    height: "auto",
    maxHeight: numericViewportHeight[100],
    padding: spacing.xl,
  },
  maxWidth: "unset",
  width: "unset",
};

const contentStyle: Interpolation = {
  width: "fit-content",
  zIndex: zIndices.modalOverModal,
};
const overlayStyle: Interpolation = { zIndex: zIndices.overlayOverModal };

type FlagRecordModalProps = {
  flaggableId: number;
  flaggableType: FlaggableType;
};

export const FlagRecordModal = NiceModal.create(
  ({ flaggableId, flaggableType }: FlagRecordModalProps) => {
    const modal = useModal();
    return (
      <FullscreenModalModal
        fullScreenModalProps={{
          showCloseButton: true,
        }}
        modalProps={{
          contentCSS: contentStyle,
          overlayCSS: overlayStyle,
        }}
        open={modal.visible}
        onOpenChange={(open) => (open ? modal.show() : modal.hide())}
        css={viewportStyle}
      >
        <FlagRecordForm
          flaggableId={flaggableId}
          flaggableType={flaggableType}
        />
      </FullscreenModalModal>
    );
  },
);
